export const FETCH_PERIODS_REQUEST = 'FETCH_PERIODS_REQUEST';
export const FETCH_PERIODS_SUCCESS = 'FETCH_PERIODS_SUCCESS';
export const FETCH_PERIODS_FAILURE = 'FETCH_PERIODS_FAILURE';

export const fetchPeriodsRequest = courseGuid => ({
  type: FETCH_PERIODS_REQUEST,
  courseGuid,
});

export const fetchPeriodsSuccess = payload => ({
  type: FETCH_PERIODS_SUCCESS,
  payload,
});

export const fetchPeriodsFailure = payload => ({
  type: FETCH_PERIODS_FAILURE,
  payload,
});
